const resizer = (width = 375) => {
	if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
		document.documentElement.style.fontSize = `${
			(document.documentElement.clientWidth / width) * 16
		}px`;
	} else if (window) {
		document.documentElement.style.fontSize = `${(window.innerWidth / width) * 16}px`;
	}
};
export const px2rem = (pxValue: number, defaultValue: string = "initial") => {
	if (typeof pxValue !== "undefined") {
		return `${Number((pxValue / 16).toFixed(4))}rem`;
	}
	return defaultValue;
};

export default resizer;
